export const APP_NAME = 'Grid Battles';
export const APP_URL = 'gridbattles.com';
